module.exports = __webpack_public_path__ + "static/media/work-record.37cb0cd4.svg";